module.exports = __webpack_public_path__ + "static/Hero-Banner-Retail-51ebeda043d626e1e29010c7754fd2d3.jpg";